// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jzaL","content":"styles_content__2ns2K"};